/**
 * TrafficTimeRangeSelector
 *
 * Time range selector buttons for traffic charts: 15m | 1h | 24h | 7d
 */

import type { TimeRange } from '../../types/security.types';

interface TrafficTimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

const RANGES: { value: TimeRange; label: string }[] = [
  { value: '15m', label: '15m' },
  { value: '1h', label: '1h' },
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
];

export function TrafficTimeRangeSelector({ value, onChange }: TrafficTimeRangeSelectorProps) {
  return (
    <div className="flex gap-1 bg-ems-bg rounded-lg p-0.5">
      {RANGES.map((range) => (
        <button
          key={range.value}
          onClick={() => onChange(range.value)}
          className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
            value === range.value
              ? 'bg-ems-bg-card text-ems-text-primary'
              : 'text-ems-text-muted hover:text-ems-text-secondary'
          }`}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
}
